import OperatorService from 'js/services/api/entity/operators.js'

export default {
  state: {
    operators: []
  },
  mutations: {
    SET_OPERATORS(state, operators) {
      state.operators = operators
    }
  },
  getters: {
    operators: state => state.operators,
    operatorById: state => id =>{
      // console.log(state.operators, id)
      if(_.isEmpty(state.operators)) return []

      return state.operators.find(i => String(i.id) === String(id))
    }
  },
  actions: {
    getOperators({commit, rootGetters}) {
      const aa = rootGetters['administrativeArea/administrativeAreaId']
      const mun = rootGetters['municipality/currentMunicipality']

      // Sin AA el listado viene paginado (todos los operadores) y el filtro
      // de municipio deja 0/1 → el UI de "Filtrar por Operador" no aparece.
      if (!aa || !mun || !mun.id) {
        commit('SET_OPERATORS', [])
        return Promise.resolve([])
      }

      // per: 0 desactiva la paginacion del backend (20 por pagina). Sin ella,
      // si la primera pagina no contiene operadores del municipio, el listado
      // queda vacio y no se muestra el boton "Operador".
      return OperatorService.index({administrative_area_id: aa, per: 0})
        .then(resp => {
          const respOperator = resp.data || []

          const operators = respOperator
            // Filter by "visible" flag
            .filter(operator => operator.visible !== false)
            // Filter by matching municipality
            .filter(operator =>
              (operator.companies || []).some(
                company => company.municipality_id == mun.id
              )
            )
            // Map normalized data
            .map(operator => {
              const logoUrl =
                (typeof operator.logo_url?.url === 'string' && operator.logo_url.url) ||
                (typeof operator.shadow_logo_url?.url === 'string' && operator.shadow_logo_url.url) ||
                (typeof operator.img_url?.url === 'string' && operator.img_url.url) ||
                ''

              return {
                ...operator,
                selected: true,
                operator_type: operator.operator_type || null,
                logo_url: logoUrl
              }
            })

          commit('SET_OPERATORS', operators)
          return operators
        })
        .catch(error => {
          console.error('Error fetching operators:', error)
          commit('SET_OPERATORS', [])
          return []
        })
    }
  }
}
